import React from "react";
import { ChannelPartners } from "../../types/serviceDetail";

interface Props {
  channelPartner: ChannelPartners[];
  sectionTitle: string | null;
  line: string | null;
  isPage?: boolean;
}

const ChannelPartner: React.FC<Props> = ({
  channelPartner,
  sectionTitle,
  line,
  isPage = false,
}) => {
  const renderTitle = (title: string | null) => {
    if (!title) return null;
    const TitleTag = isPage ? "h3" : "p";
    return (
      <TitleTag
        className="text-center font-16 text-black ff-semibold mb-4"
        dangerouslySetInnerHTML={{ __html: title }}
      />
    );
  };

  const renderLine = (line: string | null) => {
    if (!line) return null;
    return (
      <p
        className="font-12 text-grey ff-normal text-center"
        dangerouslySetInnerHTML={{ __html: line }}
      />
    );
  };

  return (
    <div className="py-2">
      {renderTitle(sectionTitle)}
      {renderLine(line)}

      <div className="container">
        <div className="row justify-content-center Partners-list-box-wrap">
          {channelPartner.map((partner) => (
            <div key={partner.id} className="col-md-3 col-4 mb-3">
              <div className="Partners-list-box p-3 bg-white rounded-3 layout-border">
                {partner.image && (
                  <img
                    src={partner.image}
                    alt={partner.alt ?? "Partner logo"} // Default alt text
                    className="img-fluid"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChannelPartner;
